import { useRouter } from "next/router";
import type { FunctionComponent } from "react";

import { mockPostiesMenu } from "./mocks";
import { Container, MenuItem, MenuItemName, StyledBaseLink, SubMenu, SubMenuItem } from "./styles";

export type Props = {
  className?: string;
};

export const PostiesHeaderMenu: FunctionComponent<Props> = ({ className }) => {
  const { asPath } = useRouter();
  const activePrimaryPath = asPath.split("/")[1];

  return (
    <Container className={className}>
      {mockPostiesMenu.map((item, index) => (
        <MenuItem key={index}>
          <StyledBaseLink $isActive={activePrimaryPath === item.urlAlias} pathname={item.urlAlias}>
            <MenuItemName>{item.name}</MenuItemName>
          </StyledBaseLink>
          {item.children && (
            <SubMenu>
              {item.children.map((child, childIndex) => (
                <SubMenuItem key={childIndex} pathname={child.urlAlias}>
                  <MenuItemName>{child.name}</MenuItemName>
                </SubMenuItem>
              ))}
            </SubMenu>
          )}
        </MenuItem>
      ))}
    </Container>
  );
};

PostiesHeaderMenu.displayName = "PostiesHeaderMenu";
